import { FC } from "react";

interface Props {
  title: string;
  description: string;
  imageUrl: string;
  id?: string;
}

export const Finish: FC<Props> = ({ title, description, imageUrl, id }) => {
  return (
    <div className="finish-item bottom-padding-large" id={id}>
      <div className="finish-item__content">
        <span className="finish-item__title h3">{title}</span>
        <div className="finish-item__divider">
          <div />
        </div>
        <span className="finish-item__description">{description}</span>
      </div>
      <div
        className="finish-item__image"
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      />
    </div>
  );
};
